import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class CommentBody extends PrimitiveValueObject<string> {
  static create(value: string): CommentBody {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new CommentBody(value);
  }
}
